/* tslint:disable */
/* eslint-disable */
/**
 * api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, toPathString, createRequestFunction } from '../../../common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from '../../../base';
/**
 * SpotApi - axios parameter creator
 * @export
 */
export const SpotApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Retrieve the Spot for a given longitude and latitude
         * @param {number} longitude The longitude of the spot to retrieve
         * @param {number} latitude The latitude of the spot to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spotGeocode: (longitude, latitude, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('spotGeocode', 'longitude', longitude);
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('spotGeocode', 'latitude', latitude);
            const localVarPath = `/spots/geocode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }
            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieve spot infos
         * @param {'tc' | 'gm'} source The source of the spot to retrieve
         * @param {string} id The id of the spot to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spotGet: (source, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('spotGet', 'source', source);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('spotGet', 'id', id);
            const localVarPath = `/spots/{source}/{id}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search spots
         * @param {string} query Text search for places. Ex: \&quot;CDG\&quot;, \&quot;Paris\&quot; or \&quot;45 rue de la Chaussée d\&#39;Antin, Paris\&quot;
         * @param {Array<string>} [sources]
         * @param {string} [country]
         * @param {string} [language]
         * @param {string} [types]
         * @param {string} [components]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spotSearch: (query, sources, country, language, types, components, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('spotSearch', 'query', query);
            const localVarPath = `/spots/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (sources) {
                localVarQueryParameter['sources'] = sources;
            }
            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            if (types !== undefined) {
                localVarQueryParameter['types'] = types;
            }
            if (components !== undefined) {
                localVarQueryParameter['components'] = components;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SpotApi - functional programming interface
 * @export
 */
export const SpotApiFp = function (configuration) {
    const localVarAxiosParamCreator = SpotApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Retrieve the Spot for a given longitude and latitude
         * @param {number} longitude The longitude of the spot to retrieve
         * @param {number} latitude The latitude of the spot to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spotGeocode(longitude, latitude, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.spotGeocode(longitude, latitude, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Retrieve spot infos
         * @param {'tc' | 'gm'} source The source of the spot to retrieve
         * @param {string} id The id of the spot to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spotGet(source, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.spotGet(source, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Search spots
         * @param {string} query Text search for places. Ex: \&quot;CDG\&quot;, \&quot;Paris\&quot; or \&quot;45 rue de la Chaussée d\&#39;Antin, Paris\&quot;
         * @param {Array<string>} [sources]
         * @param {string} [country]
         * @param {string} [language]
         * @param {string} [types]
         * @param {string} [components]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spotSearch(query, sources, country, language, types, components, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.spotSearch(query, sources, country, language, types, components, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SpotApi - factory interface
 * @export
 */
export const SpotApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SpotApiFp(configuration);
    return {
        /**
         *
         * @summary Retrieve the Spot for a given longitude and latitude
         * @param {SpotApiSpotGeocodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spotGeocode(requestParameters, options) {
            return localVarFp.spotGeocode(requestParameters.longitude, requestParameters.latitude, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve spot infos
         * @param {SpotApiSpotGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spotGet(requestParameters, options) {
            return localVarFp.spotGet(requestParameters.source, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search spots
         * @param {SpotApiSpotSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spotSearch(requestParameters, options) {
            return localVarFp.spotSearch(requestParameters.query, requestParameters.sources, requestParameters.country, requestParameters.language, requestParameters.types, requestParameters.components, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SpotApi - object-oriented interface
 * @export
 * @class SpotApi
 * @extends {BaseAPI}
 */
export class SpotApi extends BaseAPI {
    /**
     *
     * @summary Retrieve the Spot for a given longitude and latitude
     * @param {SpotApiSpotGeocodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotApi
     */
    spotGeocode(requestParameters, options) {
        return SpotApiFp(this.configuration).spotGeocode(requestParameters.longitude, requestParameters.latitude, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve spot infos
     * @param {SpotApiSpotGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotApi
     */
    spotGet(requestParameters, options) {
        return SpotApiFp(this.configuration).spotGet(requestParameters.source, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search spots
     * @param {SpotApiSpotSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotApi
     */
    spotSearch(requestParameters, options) {
        return SpotApiFp(this.configuration).spotSearch(requestParameters.query, requestParameters.sources, requestParameters.country, requestParameters.language, requestParameters.types, requestParameters.components, options).then((request) => request(this.axios, this.basePath));
    }
}
